var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 516 443",
    style: {
      enableBackground: "new 0 0 516 443"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9E9E9E;}\n\t.st1{fill:#E2E2E2;}\n\t.st2{fill:#EA6502;}\n\t.st3{fill:#2B2A29;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000095324951768123458770000004536347755831453834_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "484,421.3 34,421.3 34,361.6 484,384.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "405.1,371.8 112.9,357.9 112.9,343.6 405.1,316.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000090287601595411359970000018091489058129170104_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.2,309.9 51.9,304.8 24.9,312.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000081628662763438691850000004975219302885371056_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.2,230.7 47,234.8 18.9,233.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000037687708440326996990000013451454403546329488_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40.1,154.1 65,167.1 38.8,156.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000109730953645418488300000008636879765680333739_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84.7,88.5 104.1,108.8 82.6,90.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000151516539943054720710000010614047930602700952_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "148.2,40.9 159.9,66.5 145.6,42.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000165227775064791026990000018427673653771503510_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.7,16.6 226.5,44.5 220.8,17  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000175307027012748317250000006260381667213682349_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "303.1,18 296.6,45.4 300.1,17.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000072980311139617404350000005461463279072516264_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "377.6,45.2 362.7,69 375,43.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000135670315382921445910000013560036537496938395_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "439.3,95.1 417.5,112.7 437.3,92.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000110436939295225354150000004597491486294852497_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "481.5,162.3 455.1,171.9 480.3,159.5  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000021832364521354318100000013081896688453856384_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "499.6,239.6 471.5,240.1 499.3,236.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Radial_Repeat_x3E__00000056415510755515245990000007031040978071651984_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "491.5,318.5 464.8,309.9 492.3,315.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.8,225.8h-10.5v17.6H164v-17.6h-51v-6.3l32.8-80.5h33l-24.6,60.4h14l8.5-22.4h19.6v22.4h10.5V225.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.2,191.6c0-33.4,19.9-55.7,49.8-55.7c29.8,0,49.8,22.3,49.8,55.7s-19.9,55.7-49.8,55.7 C230.2,247.3,210.2,225,210.2,191.6z M275.5,191.6c0-17.4-5.8-27.8-15.5-27.8s-15.5,10.4-15.5,27.8c0,17.4,5.8,27.8,15.5,27.8 S275.5,209,275.5,191.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M405.1,225.8h-10.5v17.6h-32.3v-17.6h-51v-6.3l32.8-80.5h33l-24.6,60.4h14L375,177h19.6v22.4h10.5V225.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.3,274.4v16.3h-3.6v-23.1h3l13.1,16.7v-16.6h3.7v23h-3.2L117.3,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.2,290.9c-1.7,0-3.2-0.3-4.5-1c-1.3-0.6-2.5-1.5-3.5-2.6s-1.7-2.4-2.3-3.8c-0.5-1.4-0.8-2.8-0.8-4.3 s0.3-3,0.8-4.4c0.6-1.4,1.3-2.6,2.3-3.7c1-1.1,2.2-2,3.5-2.6c1.4-0.6,2.8-1,4.4-1c1.6,0,3.1,0.3,4.5,1s2.5,1.6,3.5,2.7 c1,1.1,1.7,2.4,2.2,3.8c0.5,1.4,0.8,2.8,0.8,4.3s-0.3,3-0.8,4.4c-0.6,1.4-1.3,2.6-2.3,3.7c-1,1.1-2.2,2-3.5,2.6 C164.2,290.6,162.8,290.9,161.2,290.9z M153.8,279.2c0,1.1,0.2,2.1,0.5,3.2c0.3,1,0.8,1.9,1.5,2.7c0.6,0.8,1.4,1.4,2.3,1.9 c0.9,0.5,1.9,0.7,3.1,0.7c1.2,0,2.2-0.2,3.1-0.7c0.9-0.5,1.7-1.1,2.3-1.9c0.6-0.8,1.1-1.7,1.4-2.7c0.3-1,0.5-2,0.5-3 c0-1.1-0.2-2.1-0.5-3.1s-0.8-1.9-1.5-2.7c-0.6-0.8-1.4-1.4-2.3-1.9c-0.9-0.5-1.9-0.7-3-0.7c-1.2,0-2.2,0.2-3.1,0.7 c-0.9,0.5-1.7,1.1-2.3,1.9c-0.6,0.8-1.1,1.7-1.4,2.7C154,277.1,153.8,278.2,153.8,279.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M205.3,270.9h-7.7v19.9H194v-19.9h-7.7v-3.2h19V270.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.4,290.7v-23.1h15.4v3.2h-11.7v6.9h9.8v3h-9.8v9.9L241.4,290.7L241.4,290.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M282.4,290.9c-1.7,0-3.2-0.3-4.5-1c-1.3-0.6-2.5-1.5-3.5-2.6s-1.7-2.4-2.3-3.8c-0.5-1.4-0.8-2.8-0.8-4.3 s0.3-3,0.8-4.4c0.6-1.4,1.3-2.6,2.3-3.7c1-1.1,2.2-2,3.5-2.6c1.4-0.6,2.8-1,4.4-1c1.6,0,3.1,0.3,4.5,1s2.5,1.6,3.5,2.7 c1,1.1,1.7,2.4,2.2,3.8c0.5,1.4,0.8,2.8,0.8,4.3s-0.3,3-0.8,4.4c-0.6,1.4-1.3,2.6-2.3,3.7c-1,1.1-2.2,2-3.5,2.6 C285.5,290.6,284,290.9,282.4,290.9z M275.1,279.2c0,1.1,0.2,2.1,0.5,3.2c0.3,1,0.8,1.9,1.5,2.7c0.6,0.8,1.4,1.4,2.3,1.9 c0.9,0.5,1.9,0.7,3.1,0.7c1.2,0,2.2-0.2,3.1-0.7c0.9-0.5,1.7-1.1,2.3-1.9c0.6-0.8,1.1-1.7,1.4-2.7c0.3-1,0.5-2,0.5-3 c0-1.1-0.2-2.1-0.5-3.1s-0.8-1.9-1.5-2.7c-0.6-0.8-1.4-1.4-2.3-1.9c-0.9-0.5-1.9-0.7-3-0.7c-1.2,0-2.2,0.2-3.1,0.7 c-0.9,0.5-1.7,1.1-2.3,1.9c-0.6,0.8-1.1,1.7-1.4,2.7C275.3,277.1,275.1,278.2,275.1,279.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.9,290.9c-1.8,0-3.4-0.3-4.7-0.9c-1.3-0.6-2.3-1.5-3.1-2.6s-1.3-2.3-1.7-3.7s-0.5-2.8-0.5-4.3v-11.7 h3.6v11.7c0,1.1,0.1,2.1,0.3,3.1s0.6,1.9,1,2.6c0.5,0.8,1.1,1.4,1.9,1.9c0.8,0.5,1.8,0.7,3,0.7s2.2-0.2,3-0.7 c0.8-0.5,1.5-1.1,1.9-1.9c0.5-0.8,0.8-1.7,1-2.6c0.2-1,0.3-2,0.3-3v-11.7h3.7v11.7c0,1.6-0.2,3.1-0.6,4.5s-1,2.6-1.8,3.7 c-0.8,1.1-1.8,1.9-3.1,2.5C323.2,290.6,321.7,290.9,319.9,290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.3,274.4v16.3h-3.6v-23.1h3l13.1,16.7v-16.6h3.7v23h-3.2L351.3,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M385.6,290.7v-23.1h8.2c2.5,0,4.6,0.5,6.2,1.5c1.7,1,2.9,2.4,3.8,4.2c0.8,1.7,1.3,3.7,1.3,5.8 c0,2.3-0.5,4.4-1.4,6.1c-0.9,1.7-2.2,3.1-3.9,4c-1.7,1-3.7,1.4-5.9,1.4L385.6,290.7L385.6,290.7z M401.4,279.2 c0-1.6-0.3-3.1-0.9-4.3s-1.5-2.2-2.6-2.9s-2.5-1.1-4.1-1.1h-4.5v16.6h4.5c1.6,0,3-0.4,4.1-1.1c1.1-0.7,2-1.7,2.6-3 C401.1,282.2,401.4,280.8,401.4,279.2z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000015336376286452845450000001669240880850737033_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.1581a53933128490e641cec856352f1c.svg";
export { ForwardRef as ReactComponent };